import { render, staticRenderFns } from "./yingfu.vue?vue&type=template&id=8e2d0156&scoped=true&"
import script from "./yingfu.vue?vue&type=script&lang=js&"
export * from "./yingfu.vue?vue&type=script&lang=js&"
import style0 from "./yingfu.vue?vue&type=style&index=0&id=8e2d0156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2d0156",
  null
  
)

export default component.exports